export default __webpack_public_path__ + "static/oneshift-logo-colour-8faab415a8bfe7f86e23211459e557c4.png";